// extracted by mini-css-extract-plugin
export default {"wrapper":"optionsBar_wrapper__M6AWM","caption":"optionsBar_caption__nGu-l"};